import { useEffect } from "react";
import { formatRoundDownDecimal } from "../../../utils";

export interface MinuteData {
    min: number;
    ch1: number;
    ch2: number;
    ch3: number;
    ch4: number;
    ch5: number;
    ch6: number;
    earth_leak: number;
}

export interface HourlyData {
    hour: number;
    mins_data: MinuteData[];
}

export interface calendarItem {
    day: string;
    date: string;
    day_kwh: any;
    day_amount: any;
    data: HourlyData[];
}

export type Calendar2Props = {
    calendarItem: calendarItem;
    mode: string;
    measuredCHFlag: number;
    // kw
    max_kw_by_month?: any;
    final_day_max_kw?: any;
    final_time_max_kw?: any;
    // kwh 
    max_total_kwh_by_month?: any;
    max_kwh_by_month?: any;
    final_day_max_kwh?: any;
    final_hour_max_kwh?: any;
    // money
    max_total_money_by_month?: any;
    max_money_by_month?: any;
    jpy_per_kwh?: any;
    hourFinalMax?: any;
    minuteFinalMax?: any;
};

export const Calendar2 = (props: Calendar2Props) => {
    const {  
        final_day_max_kw, final_time_max_kw, max_kw_by_month,
        calendarItem, mode, measuredCHFlag, hourFinalMax, minuteFinalMax } = props;
    
    const getStyleColor = (max_value: any,value:any) => {
        if(value == '-' ||  value == '0'){
            return 'white';
        }
        return `rgba(255,0,0,${value/max_value})`;
    }

    const colorKw = getStyleColor(max_kw_by_month,calendarItem.day_kwh);

    const getFontWeight = (max_value:any,value:any) => {
        if(value && max_value){
            if(value == max_value)
                return "bold";
            else{
                return "normal";
            }
        }else{
            return "normal";
        }
    }

    useEffect(()=>{
        if(final_time_max_kw)
        {
            const time = final_time_max_kw.split("h");
            if(time[1] === "30"){
            }else if(time[1] === "00"){
            }
        }
        if(calendarItem.data.length > 0){
            let allKw0Values: number[] = [];
            let allKw30Values: number[] = [];
            let allKwhValues: number[] = [];
            
            const channelKey = `ch${measuredCHFlag}` as keyof MinuteData;
            
            calendarItem.data.forEach((hourData: HourlyData) => {
                if (hourData.mins_data) {
                    const min0Data = hourData.mins_data.find(m => m.min === 0);
                    const min30Data = hourData.mins_data.find(m => m.min === 30);
                    
                    if (min0Data && min0Data[channelKey] !== null && min0Data[channelKey] !== undefined) {
                        allKw0Values.push(Number(min0Data[channelKey]));
                    }
                    if (min30Data && min30Data[channelKey] !== null && min30Data[channelKey] !== undefined) {
                        allKw30Values.push(Number(min30Data[channelKey]));
                    }
                    
                    if (min0Data && min30Data && 
                        min0Data[channelKey] !== null && min30Data[channelKey] !== null) {
                        const hourKwh = (Number(min0Data[channelKey]) + Number(min30Data[channelKey])) / 2;
                        allKwhValues.push(hourKwh);
                    }
                }
            });
        }        
    },[measuredCHFlag,calendarItem]);

    const styleDayKw =  {
        textAlign: calendarItem.day_kwh === "-" ? 'center' as const : 'right' as const,
        paddingRight: calendarItem.day_kwh === "-" ? '0px' : '2px',
        background: colorKw,
        fontWeight: calendarItem.day_kwh == max_kw_by_month ? "bold" : "normal",
    }
    
    return (
        <tr>
            {mode === 'calendar2' &&
                <>
                    <td className={'sticky-col first-col'} style={{backgroundColor:"white",padding:"0px",margin:"0px"}}>
                        <div style={styleDayKw}>
                            {formatRoundDownDecimal(calendarItem.day_kwh,0)}
                        </div>
                    </td>
                    <td className={'sticky-col second-col'} style={{ textAlign: 'center', fontWeight: 'bold', backgroundColor: '#ccccff'}}>{calendarItem.date}</td>
                    <td className={'sticky-col third-col'} style={{ textAlign: 'center', fontWeight: 'bold', backgroundColor: '#ccccff', width: '15px'}}>{calendarItem.day}</td>
                    {[...Array(48)].map((x, i) => {
                        const hourIndex = Math.floor(i / 2);
                        const isKw0 = i % 2 === 0;
                        const hourData = calendarItem.data.find(h => h.hour === hourIndex);
                        let channelValue:any = "-";
                        if (hourData && hourData.mins_data) {
                            const minData = hourData.mins_data.find(m => m.min === (isKw0 ? 0 : 30));
                            if (minData) {
                                const channelKey = `ch${measuredCHFlag}` as keyof MinuteData;
                                channelValue = minData[channelKey] !== null ? minData[channelKey] : "-";
                            }
                        }

                        return (
                            <td key={i} style={{
                                textAlign: 'center',
                                backgroundColor: calendarItem.data.length > 0
                                    ? getStyleColor(max_kw_by_month, channelValue)
                                    : 'white',
                                fontWeight: getFontWeight(calendarItem.day_kwh, channelValue),
                                color: calendarItem.date == final_day_max_kw && 
                                       hourIndex == hourFinalMax && 
                                       (isKw0 ? 0 : 30) == minuteFinalMax &&
                                       channelValue != 0
                                    ? "white" 
                                    : "black"
                            }}>
                                {channelValue !== "-" 
                                    ? formatRoundDownDecimal(channelValue, 0)
                                    : "-"
                                }
                            </td>
                        );
                    })}
                </>
            }
        </tr>
    );
};

export default Calendar2;
